// extracted by mini-css-extract-plugin
export default {"bannerContainer":"style_bannerContainer__vZ1UD","smallBanner":"style_smallBanner__vOZJ2","playLogoContainer":"style_playLogoContainer__dGtYo","closeIcon":"style_closeIcon__BqEhi"};